import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardCheck, PenTool, Rocket, Activity } from 'lucide-react';
const steps = [{
  icon: ClipboardCheck,
  title: 'Diagnóstico Gratuito',
  description: 'Evaluamos el estado actual de su piscina sin costo ni compromiso.'
}, {
  icon: PenTool,
  title: 'Plan Personalizado',
  description: 'Diseñamos una propuesta a medida según sus necesidades y presupuesto.'
}, {
  icon: Rocket,
  title: 'Inicio en 72 Horas',
  description: 'Una vez aprobado, nuestro equipo comienza a trabajar rápidamente.'
}, {
  icon: Activity,
  title: 'Monitoreo Continuo',
  description: 'Disfrute de 2-3 meses de mantenimiento gratis para asegurar resultados perfectos.'
}];
export function Process() {
  return <section className="py-20 bg-navy-900 text-white relative overflow-hidden" data-id="element-205">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden opacity-10 pointer-events-none" data-id="element-206">
        <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-pool-500 blur-3xl" data-id="element-207"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-gold-500 blur-3xl" data-id="element-208"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-209">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-210">
          <h2 className="text-gold-400 font-semibold tracking-wider uppercase text-sm mb-2" data-id="element-211">
            Nuestro Proceso
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-212">
            Simple, Transparente y Eficiente
          </h3>
        </div>

        <div className="relative" data-id="element-213">
          {/* Connecting Line (Desktop only) */}
          <div className="hidden lg:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-navy-800 border-t border-dashed border-pool-500/50 z-0" data-id="element-214"></div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-6 relative z-10" data-id="element-215">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="flex flex-col items-center text-center" data-id="element-216">
                <div className="relative mb-6" data-id="element-217">
                  <div className="w-24 h-24 rounded-full bg-navy-800 border-2 border-pool-500 flex items-center justify-center shadow-[0_0_15px_rgba(0,119,182,0.3)]" data-id="element-218">
                    <step.icon size={36} className="text-gold-400" data-id="element-219" />
                  </div>
                  <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-gold-500 text-navy-900 font-bold flex items-center justify-center text-sm" data-id="element-220">
                    {index + 1}
                  </div>
                </div>
                <h4 className="text-xl font-bold mb-3" data-id="element-221">{step.title}</h4>
                <p className="text-gray-400 text-sm leading-relaxed max-w-xs" data-id="element-222">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>

        <div className="mt-16 text-center" data-id="element-223">
          <a href="#contacto" className="inline-block bg-pool-600 hover:bg-pool-500 text-white font-semibold py-3 px-8 rounded-full transition-colors shadow-lg" data-id="element-224">
            Comenzar mi Proyecto
          </a>
        </div>
      </div>
    </section>;
}